
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.2","xmlns":"http://www.w3.org/2000/svg","overflow":"visible","preserveAspectRatio":"none","viewBox":"0 0 34 34","height":"32","width":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(1 1)"}},[_c('g',{attrs:{"fill-rule":"nonzero","fill":"none"}},[_c('g',{attrs:{"transform":"translate(2.5 5)"}},[_c('circle',{attrs:{"r":"1.879","cy":"5.57","cx":"2.346","fill":"#000","vector-effect":"non-scaling-stroke"}}),_c('circle',{attrs:{"r":"1.879","cy":"14.334","cx":"8.638","fill":"#000","vector-effect":"non-scaling-stroke"}}),_c('circle',{attrs:{"r":"1.379","cy":"2.716","cx":"24.205","stroke":"#000","vector-effect":"non-scaling-stroke"}}),_c('path',{attrs:{"fill":"#000","d":"M16.219 2.716a1.879 1.879 0 110 3.758 1.879 1.879 0 010-3.758zm0 1a.879.879 0 100 1.758.879.879 0 000-1.758z","vector-effect":"non-scaling-stroke"}})]),_c('path',{attrs:{"fill":"#000","d":"M18.063 10.192a1 1 0 01.303 1.288l-.067.107-5.882 8.283a1 1 0 01-1.186.35 1 1 0 01-1.116-.265l-.078-.1-5.263-7.683a1 1 0 011.573-1.229l.077.1 4.816 7.029 5.429-7.643a1 1 0 011.394-.237zM25.245 6.98l.459 1.946-5.845 1.378-.459-1.947zM28.226 24.811a1 1 0 01.116 1.994l-.116.006H3a1 1 0 01-.117-1.993L3 24.811h25.226z","vector-effect":"non-scaling-stroke"}})])])])
          )
        }
      }
    